import { Button } from "@/components/ui/button";
import type { Note } from "../../types.ts";
import { SeverityIcon } from "../severity-icon";

export function GeneralNotesStrip({
	notes,
	onViewAll,
}: {
	notes: Note[];
	onViewAll: () => void;
}) {
	if (notes.length === 0) return null;
	return (
		<section
			className="general-notes-strip"
			aria-label="Observações gerais da obra"
			data-testid="general-notes-strip"
		>
			<div className="general-notes-strip__head">
				<span className="general-notes-strip__title">
					Observações gerais da obra
				</span>
				<Button type="button" variant="link" size="sm" onClick={onViewAll}>
					Ver todas
				</Button>
			</div>
			<ul className="general-notes-strip__list">
				{notes.slice(0, 2).map((note) => (
					<li
						key={note.id}
						className="general-notes-strip__item"
						data-severity={note.severity}
					>
						<SeverityIcon severity={note.severity} />
						<span className="general-notes-strip__body">{note.body}</span>
					</li>
				))}
			</ul>
		</section>
	);
}
